export default __webpack_public_path__ + "static/media/patrick-tomasso-Oaqk7qqNh_c-unsplash.a573115a.jpg";